export enum Default_Milestones { //Is only for data type insertion
  Insemination="Insemination",
  Weaning="Weaning",
  Farrowing="Farrowing"
}

export type Milestone = {
  milestoneId: number;
  milestoneName: string;
};
  
export const TestData: Milestone[] = [
  {
    milestoneId: 1,
    milestoneName: Default_Milestones.Insemination
  },
  {
    milestoneId: 2,
    milestoneName: Default_Milestones.Farrowing
  },
  {
    milestoneId: 3,
    milestoneName: Default_Milestones.Weaning
  },
  {
    milestoneId: 4,
    milestoneName: "Moved to Farrowing"
  },
  {
    milestoneId: 5,
    milestoneName: "Breeding"
  },
]

